import { WEIGHT_UNIT_ABBREVIATION, type WeightUnit } from "@forgepoint/shared";
import { formatWeight } from "@/lib/utils";

interface LineWeightSublineProps {
  weight: string | null | undefined;
  unit: WeightUnit | null | undefined;
}

/**
 * Muted line total weight under a quote line's quantity.
 * @param props - The line's total weight and its unit
 * @returns The weight subline, or null when the weight or unit is unknown
 */
export function LineWeightSubline({ weight, unit }: LineWeightSublineProps) {
  if (!weight || !unit) {
    return null;
  }
  return (
    <span className="px-1 sm:px-2 text-[10px] sm:text-xs tabular-nums whitespace-nowrap text-muted-foreground">
      {formatWeight(weight)} {WEIGHT_UNIT_ABBREVIATION[unit]}
    </span>
  );
}
